
export const resizeSignCanvasToAspectRatio = (aspectRatio: number, canvas: HTMLCanvasElement, targetWidth: number) => {
  const resizedCanvas = document.createElement("canvas");
  const ctx = resizedCanvas.getContext("2d");

  const originalWidth = canvas.width;
  const originalHeight = canvas.height;

  const targetHeight = targetWidth / aspectRatio;

  const scaleFactor = window.devicePixelRatio || 1;

  resizedCanvas.width = targetWidth * scaleFactor;
  resizedCanvas.height = targetHeight * scaleFactor;

  ctx?.scale(scaleFactor, scaleFactor);

  const scaleWidth = targetWidth / originalWidth;
  const scaleHeight = targetHeight / originalHeight;

  const minScaleFactor = Math.min(scaleWidth, scaleHeight);

  const newWidth = originalWidth * minScaleFactor;
  const newHeight = originalHeight * minScaleFactor;

  const offsetX = (targetWidth - newWidth) / 2;
  const offsetY = (targetHeight - newHeight) / 2;

  ctx?.drawImage(canvas, 0, 0, originalWidth, originalHeight, offsetX, offsetY, newWidth, newHeight);

  return resizedCanvas;
};